import { Section } from '~/shared/section/Section';
import { useGoalsAndInterventionsWizard } from '../GoalsAndInterventionsWizardContext';
import { GoalCard } from '../../goals/GoalCard';

export function ExistingGoals() {
	const { existingGoals, existingInterventions, dispatch } = useGoalsAndInterventionsWizard();
	if (existingGoals.length === 0) {
		return (
			<div className="flex flex-col gap-4">
				<Section>
					<div className="text-center text-sm text-gray-500">No existing goals for this visit</div>
				</Section>
			</div>
		);
	}
	return (
		<div className="flex flex-col space-y-16 px-1 py-2">
			<div className="flex flex-col space-y-4">
				{existingGoals.map(x => {
					return (
						<GoalCard
							key={x.id}
							title={x.title}
							definitionText={x.definitionText}
							onGoalSelect={() => {
								dispatch({
									type: 'EXISTING_GOAL_SELECTED',
									goal: x,
									existingInterventions: existingInterventions.filter(y => x.interventionIds.includes(y.id))
								});
							}}
						/>
					);
				})}
			</div>
		</div>
	);
}
